import styled from "styled-components"
import colors from "../../utils/style/colors.tsx"
import rect1 from "../../assets/images/rect-1.png"
import rect2 from "../../assets/images/rect-2.png"
import rect3 from "../../assets/images/rect-3.png"
import rect4 from "../../assets/images/rect-4.png"

const ProcessusContainer = styled.div`
    display: flex;

    @media (max-width: 1190px) {
        display: grid;
        gap: 30px;
        grid-template-columns: repeat(2, 1fr);
        justify-items: center;
    }

    @media (max-width: 780px) {
        grid-template-columns: repeat(1, 1fr);
        gap: 10px;
    }
`

const Etape = styled.div`
    position: relative;
    width: 24%;
    margin-right: 1%;
    height: 115px;

    @media (max-width: 1190px) {
        width: 80%;
    }

    @media (max-width: 780px) {
        width: 65%;
        height: 130px;
        position: relative;
        left: 12px;
    }

    @media (max-width: 480px) {
        width: 75%;
        height: 120px;
    }
`

const Rectangle = styled.img`
    position: absolute;
    left: 0;
    z-index: 0;
    height: 110%;
    width: 100%;

    @media (max-width: 768px) {
        height: 90%;
        width: 90%;
        position: absolute;
        left: 7px;
    }
`

const TextContainer = styled.div`
    display: flex;
    height: 100%;
    align-items: center;

    @media (max-width: 768px) {
        height: 82%;
    }
`

const Numero = styled.span`
    font-family: "Archivo", sans-serif;
    font-size: 18px;
    color: ${colors.black};
    position: relative;
    z-index: 1;
    margin: 0;
    margin-left: 10%;
    border: solid 4px black;
    background-color: white;
    height: fit-content;
    padding: 1px 3px 3px 7px;
    border-radius: 70px;

    @media (max-width: 900px) {
        border: solid 2px black;
        font-size: 16px;
        padding: 1px 3px 2px 6px;
    }
`

const Text = styled.p`
    font-family: "Archivo Black", sans-serif;
    color: ${colors.white};
    -webkit-text-stroke-color: ${colors.black};
    -webkit-text-stroke-width: 0.5px;
    text-shadow: 2px 2px ${colors.black};
    font-size: 16px;
    position: relative;
    z-index: 1;
    margin: 0;
    width: 55%;
    padding-left: 10px;

    @media (max-width: 1400px) {
        font-size: 14px;
    }

    @media (max-width: 1190px) {
        font-size: 16px;
    }

    @media (max-width: 900px) {
        font-size: 14px;
    }

    @media (max-width: 780px) {
        font-size: 16px;
    }

    @media (max-width: 480px) {
        font-size: 14px;
    }
`

function Processus() {
    return (
        <ProcessusContainer>
            <Etape>
                <Rectangle src={rect1} alt="processus : etape 1" />
                <TextContainer>
                    <Numero>1.</Numero>
                    <Text>Premier rendez-vous pour fixer vos objectifs</Text>
                </TextContainer>
            </Etape>
            <Etape>
                <Rectangle src={rect2} alt="processus : etape 2" />
                <TextContainer>
                    <Numero>2.</Numero>
                    <Text>Validation, conception, design et maquettage </Text>
                </TextContainer>
            </Etape>
            <Etape>
                <Rectangle src={rect3} alt="processus : etape 3" />
                <TextContainer>
                    <Numero>3.</Numero>
                    <Text>Retours et création de votre projet</Text>
                </TextContainer>
            </Etape>
            <Etape>
                <Rectangle src={rect4} alt="processus : etape 4" />
                <TextContainer>
                    <Numero>4.</Numero>
                    <Text>
                        Rendu des designs et/ou mise en ligne de votre site web
                    </Text>
                </TextContainer>
            </Etape>
        </ProcessusContainer>
    )
}

export default Processus
